module.exports = __webpack_public_path__ + "static/media/previewBg.d1be4512.svg";